import { AxiosRequestConfig } from "axios";
import { when } from "mobx";
import { getPddDeviceFingerPrinterFetcherInstance } from "./PddDeviceFingerPrintFetcher";

const PddDeviceFingerPrintInterceptor = async (config: AxiosRequestConfig) => {
    const pddDeviceFingerPrintFetcherInstance = getPddDeviceFingerPrinterFetcherInstance();

    if (!pddDeviceFingerPrintFetcherInstance) return config;

    if (pddDeviceFingerPrintFetcherInstance.loading) {
        await when(() => !pddDeviceFingerPrintFetcherInstance.loading);
    }

    const { xPddPati, xPddPageCode } = pddDeviceFingerPrintFetcherInstance;

    if (xPddPati) {
        config.headers["X-PDD-Pati"] = xPddPati;
    }

    if (xPddPageCode) {
        config.headers["X-PDD-PageCode"] = xPddPageCode;
    }

    return config;
};

export default PddDeviceFingerPrintInterceptor;
